/**
 * Created by Alex Aguilar on 7/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('generateFlightsCtrl', generateFlightsCtrl)
        .controller('deleteGenerateItineraryCtrl', deleteGenerateItineraryCtrl);

    generateFlightsCtrl.$inject = ['linkService', 'tabAdminFlights', 'itineraries', 'generateFlights',
        'generateFlightService', 'datePickerService', 'dateService'];
    deleteGenerateItineraryCtrl.$inject = ['$stateParams', '$uibModalInstance','generateFlightService','generateFlight'];

    function generateFlightsCtrl(linkService, tabAdminFlights, itineraries, generateFlights,
                                 generateFlightService, datePickerService, dateService){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabAdminFlights;
        vm.itineraries = itineraries;
        vm.generateFlights = generateFlights;
        vm.FlightsLength = generateFlights.length;

        vm.tomorrow = new Date();
        vm.tomorrow.setHours(0,0,0);
        vm.today = new Date();
        vm.today.setHours(0,0,0);
        vm.lastGenerateFlight = null;

        if(vm.FlightsLength > 0){
            vm.tomorrow = dateService.getDateByDateZone(generateFlights[vm.FlightsLength - 1].endDate); //new Date(generateFlights[vm.FlightsLength - 1].endDate);
            if(vm.today.getTime() > vm.tomorrow.getTime()){
                vm.tomorrow = vm.today;
            }else{
                vm.tomorrow.setDate(vm.tomorrow.getDate() + 1);
            }

            vm.lastGenerateFlight = generateFlights[vm.FlightsLength - 1];
        }

        vm.generateFlightForm = {
            'itinerary': null,
            'dateFrom': vm.tomorrow,
            'dateTo': vm.tomorrow
        }

        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();


        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.tomorrow
            },
            closed: function(args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.cancel = function(){
            linkService.reloadRoute('generateFlights', null);
        }

        vm.generateFlight = function(isValid, generateFlightForm){
            if(isValid){
                var save = {
                    "startDate": generateFlightForm.dateFrom,
                    "endDate": generateFlightForm.dateTo,
                    "itineraryId": parseInt(linkService.getLinkId(generateFlightForm.itinerary._links.self.href))
                }
                generateFlightService.saveGenerateFlight(save)
                    .then(function(){
                        vm.cancel();
                    });
            }
        }
    }

    function deleteGenerateItineraryCtrl($stateParams,$uibModalInstance,generateFlightService,generateFlight){
        var vm = this;
        vm.generateFlight = generateFlight.data;

        vm.confirmDeleteGenerateItinerary = function(){
            generateFlightService.deleteGenerateItinerary($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
